import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'during_the_recruitment_process_do_materials_such_as_job_desc_or'

export const dataPointDefinition = {
  retracedId: 'during_the_recruitment_process_do_materials_such_as_job_desc_or',
  name: "During the recruitment process, do materials such as job description or job application forms ever reference an applicant's race, ethnic group, skin color, sex (gender), religion, political opinion, national extraction, social origin, disability, HIV/AIDS status, sexual orientation, pregnancy/maternity status, marital status, family responsibilities, age (other than the legal minimum age) or nationality/foreign migrant worker status?",
  description:
    'Answer Yes if hiring materials (such as job descriptions or application forms) ever mention any of these elements. However, regarding age, Answer No if recruitment materials refer to age in order to meet the legal minimum age requirements, including legal minimum age requirements for hazardous work.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'disc-1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5130,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
